<app-loading [show]="loading"></app-loading>
<iframe
  src="/assets/redoc-static.html"
  frameborder="0"
  allow="fullscreen"
  class="w-full h-full"
  (load)="teste()"
></iframe>
<!-- <redoc
  spec-url="/assets/swagger.json"
  expand-responses="200,201"
  hide-download-button
  path-in-middle-panel
>
</redoc> -->
